import { createStructuredSelector } from 'reselect';
import {
    TASK_EMPLOYEE_AUDIT_LIST,
    TASK_EMPLOYEE_AUDIT_LIST_SUCCESS,
    TASK_EMPLOYEE_AUDIT_LIST_ERROR,
    TASK_EMPLOYEE_AUDIT_MODAL_SET
} from '../../actions';

export const NAME_TASK_EMPLOYEE_AUDIT = 'task_employee_audit';

export const TaskEmployeeAuditList = (id_task) => ({
    type: TASK_EMPLOYEE_AUDIT_LIST,
    payload: { id_task }
});

export const TaskEmployeeAuditListSuccess = (data) => ({
    type: TASK_EMPLOYEE_AUDIT_LIST_SUCCESS,
    payload: data
});

export const TaskEmployeeAuditListError = (error) => ({
    type: TASK_EMPLOYEE_AUDIT_LIST_ERROR,
    payload: error
});

export const TaskEmployeeAuditModalSet = (modal) => ({
    type: TASK_EMPLOYEE_AUDIT_MODAL_SET,
    payload: modal
});

const task_employee_audit = (state) => state[NAME_TASK_EMPLOYEE_AUDIT];
export const TaskEmployeeAuditSelector = createStructuredSelector({ task_employee_audit });
